import type { AnnouncementBar } from '../../domain/blocs/AnnouncementBar'

export const mapAnnouncementBarFromApi = (announcementBar): AnnouncementBar | undefined => {
  if (!announcementBar?.fields) return undefined
  const announcementBarObj: AnnouncementBar = {
    name: '',
    content: null,
    displayOn: [],
    partnerFilter: [],
    tags: [],
    createdAt: new Date(),
  }
  announcementBarObj.name = announcementBar.fields.name || ''
  announcementBarObj.content = announcementBar.fields.content || null
  announcementBarObj.displayOn = announcementBar.fields.displayOn || []
  announcementBarObj.partnerFilter = announcementBar.fields.partnerFilter || []
  announcementBarObj.tags = announcementBar.metadata.tags.map((tag) => tag.sys.id)
  announcementBarObj.createdAt = new Date(announcementBar.sys.createdAt)
  return announcementBarObj
}
